import { useEffect, useCallback, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { THEME_TYPE } from 'consts/data';
import { setThemeLocalStorage } from 'helpers/storage';
import actions from 'redux/actions';
import ThemeServices from 'services/ThemeServices';

const { changeTheme } = actions;

export default () => {
  const dispatch = useDispatch();
  const [isOldUI, setOldUI] = useState(ThemeServices.isTheOldUI());
  const theme = useSelector((state) => state.othersReducer.theme);
  const isDarkTheme = theme === THEME_TYPE.dark;

  const toggleTheme = useCallback(() => {
    if (theme === THEME_TYPE.dark) {
      dispatch(changeTheme(THEME_TYPE.light));
      setThemeLocalStorage(THEME_TYPE.light);
      return;
    }

    setThemeLocalStorage(THEME_TYPE.dark);
    dispatch(changeTheme(THEME_TYPE.dark));
  }, [theme, dispatch]);

  const toggleOldUI = useCallback(() => {
    setOldUI((oldUI) => {
      ThemeServices.setUI(!oldUI);
      return !oldUI;
    });
  }, []);

  useEffect(() => {
    const htmlElement = document.querySelector('html');
    htmlElement.className = htmlElement?.className || '';

    switch (theme) {
      case THEME_TYPE.light:
        htmlElement.classList.remove('dark-theme');
        htmlElement.classList.remove(THEME_TYPE.dark);
        htmlElement.classList.add(THEME_TYPE.light);
        return;

      case THEME_TYPE.dark:
        htmlElement.classList.add('dark-theme');
        htmlElement.classList.add(THEME_TYPE.dark);
        htmlElement.classList.remove(THEME_TYPE.light);
        return;

      default:
        htmlElement.classList.add(THEME_TYPE.light);
        return;
    }
  }, [theme]);

  useEffect(() => {
    const htmlElement = document.querySelector('html');
    htmlElement.className = htmlElement?.className || '';

    if (isOldUI) {
      htmlElement.classList.remove('admin-v2');
    } else {
      htmlElement.classList.add('admin-v2');
    }
  }, [isOldUI]);

  return { theme, isOldUI, isDarkTheme, toggleTheme, toggleOldUI };
};
